import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify/lib";

import fr from 'vuetify/es5/locale/fr'

const vuetify = new Vuetify({
  icons: {
    iconfont: "mdi"
  },

  lang: {
    locales: {
      fr
    },
    current: 'fr'
  }
});

Vue.use(Vuetify);

export default vuetify;
